import React, { Component } from 'react';
import { Segment } from 'semantic-ui-react';

export default class RightMenu extends Component {
  render() {
    return <Segment className="br0 h100">salam</Segment>;
  }
}
